import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEsc: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconEsc"><Path d="M7.5 3.9165C4.66638 5.49732 2.75 8.52488 2.75 12C2.75 17.1087 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1087 21.25 12C21.25 8.54872 19.3598 5.53888 16.5582 3.94924M12 1.75V5.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconEsc;
